// extracted by mini-css-extract-plugin
export var grid = "StrapiLogoGallery-module--grid--15364";
export var imageWrapper = "StrapiLogoGallery-module--image-wrapper--d7af8";
export var logoGallery = "StrapiLogoGallery-module--logo-gallery--01d82";
export var logoImage = "StrapiLogoGallery-module--logo-image--1e601";
export var logoName = "StrapiLogoGallery-module--logo-name--e2e32";